// cards/PendingApprovalsCard.tsx
import { useCallback, useEffect, useState } from "react";
import { gxDashboardPendingApprovalCountApi } from "@/app/apiConfig/services/customerAbstractApiLayer";
import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";

const PENDING_APPROVAL_STATUS_CODE = "4415";

interface DashboardCardProps {
  title?: string;
}

const PendingApprovalsCard = ({ title = "" }: DashboardCardProps) => {
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchPendingApprovalCount = useCallback(async () => {
    setLoading(true);
    try {
      const result = await gxDashboardPendingApprovalCountApi({
        // pageNo: 1,
        // pageSize: 100,
        status: PENDING_APPROVAL_STATUS_CODE,
      });
      setTotal(result?.data?.total ?? 0);
    } catch (error) {
      console.error("PendingApprovalsCard: failed to load count", error);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPendingApprovalCount();
  }, [fetchPendingApprovalCount]);

  return (
    <div className="gx-alter-card relative">
      {loading && (
        <div className="gx-bene-form-container-loading-overlay">
          <SubmitLoading />
        </div>
      )}
      <h3 className="gx-alter-approval-header-text gx-p16-sb">{title}</h3>
      <span className="gx-alter-approval-text-value gx-36-sb">{total}</span>
      <p className="alter-approval-policy-text_green gx-p14-b">
        Needs your action
      </p>
    </div>
  );
};

export default PendingApprovalsCard;

// // cards/PendingApprovalsCard.tsx
// interface DashboardCardProps {
//   title?: string;
// }

// const PendingApprovalsCard = ({ title = "" }: DashboardCardProps) => (
//   <div className="gx-alter-card">
//     <h3 className="gx-alter-approval-header-text gx-p16-sb">{title}</h3>
//     <span className="gx-alter-approval-text-value gx-36-sb">2</span>
//     <p className="alter-approval-policy-text_green gx-p14-b">
//       Needs your action
//     </p>
//   </div>
// );

// export default PendingApprovalsCard;
